import React, { useEffect, useState } from "react";

import { Row, Modal } from "react-bootstrap";
import { withRouter } from "react-router-dom";

import WorksiteManagement from "../../../Worksite/WorksiteManagement.component";

// redux
import { connect } from "react-redux";
import { getWorksites } from "../../../../../redux/worksites/action";
import {
  setModalWaitingToOpen,
  setAddSiteModal,
  setEditAlertModal,
} from "../../../../../redux/modals/action";
import { updateActiveNavItem } from "../../../../../redux/sideMenu/menu.action";
import { setShowFilters } from "../../../../../redux/mobileView/action";

import { Trans, useTranslation } from "react-i18next";

// Button Component
import Button from "../../../../../components/Button/Button.component";

//Custom Components
import WorksiteActionBar from "../../../Worksite/WorksiteActionBar.component";
import WorksiteCard from "../../../Worksite/WorksiteCard.component";
// import SearchBox from "../../../../../components/SearchBox.component";
import SearchBox from "../../../../../components/SearchBox/Searchbox.component";
import WorksiteList from "../../../Worksite/WorksiteList.component";
import WorksiteDropdownFilter from "../../../Worksite/WorksiteDropdownFilter.component";
import WorksiteOverview from "../../../Worksite/WorksiteOverview.component";
import AddWorsiteStepper from "./AddWorkSiteStepper";

import CommonSuccessMessage from "../../../common/CommonSuccessMessage.component";

import PermissionCheck from "../../../../../components/PermissionCheck/PermissionCheck";
import ModalPopup from "../../../../../components/ModalPopupComponent/ModalPopup.component";

import {
  WorksitePanelStyled,
  WorsiteDetailHeading,
  RightIconImage,
  SearchBoxWrapper,
  SearchFilter,
  FilterWrapper,
  FilterIconDiv,
  CloseIconDiv,
  FilterBackDiv,
  CloseBackDiv,
  FilterOnclickDes,
  FilterDesWrapper,
  WorksiteMobileListWrapper,
  MobileView,
  DesktopView,
  ActionBarWrapper,
  ActionBarButtons,
} from "./worksitePanel.styles";

function WorksitePanel(props) {
  let {
    setAddSiteModal,
    addSiteModal,
    updateActiveNavItem,
    setShowFilters,
    showFilters,
    worksiteName,
    isSuperAdmin,
    editForm,
    setEditAlertModal,
    setModalWaitingToOpen,
  } = props;

  const { t } = useTranslation();
  const [worksiteBulkUploadShow, setWorksiteBulkUploadShow] = useState(false);
  const [SearchText, setSearchText] = useState("");
  const [filterAccountId, setFilterAccountId] = useState("all");
  const [showWorksiteDetail, setShowWorksiteDetail] = useState(false);

  useEffect(() => {
    updateActiveNavItem("worksites");
  }, []);

  const [isOpen, setIsOpen] = useState(false);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  return (
    <WorksitePanelStyled>
      <DesktopView>
        <PermissionCheck section="DASHBOARD" permissionName="WORKSITE_MANAGEMENT" actionName="add">
          <Row className="m-0 p-0">
            <div className="mr-2 pl-0">
              <Button
                iconClass="add"
                label={t("Add Worksite")}
                onClick={() => (editForm ? setAddSiteModal(true) : setEditAlertModal(true))}
                showIcon
                buttonType="secondary"
              />
            </div>
            {/* commented as part of SIER-5320 <div className="mr-2 pl-0">
              <Button
                disabled
                iconClass="bulk-upload"
                label={t("Bulk Upload")}
                onClick={() => setWorksiteBulkUploadShow(true)}
                showIcon
                type="secondary"
              />
            </div> */}
            {/* <Col  md={{ offset: 5 }}><SearchAWorksite /></Col> */}
          </Row>
        </PermissionCheck>
        <WorksiteManagement />
      </DesktopView>

      <MobileView>
        <ActionBarWrapper>
          <ActionBarButtons>
            <WorksiteActionBar
              setAddSiteModal={setAddSiteModal}
              setWorksiteBulkUploadShow={setWorksiteBulkUploadShow}
            />
          </ActionBarButtons>
        </ActionBarWrapper>

        {!showWorksiteDetail ? (
          <>
            <WorksiteCard />

            <SearchFilter>
              <SearchBoxWrapper>
                <SearchBox
                  label={"Your worksite"}
                  searchText={SearchText}
                  setSearchText={setSearchText}
                  placeholder={t("Search a worksite")}
                  onChange={(e) => setSearchText(e.target.value)}
                />
              </SearchBoxWrapper>

              {isSuperAdmin && (
                <FilterWrapper onClick={handleToggle}>
                  {isOpen ? (
                    <CloseBackDiv>
                      <CloseIconDiv className="icon icon-cancel" />
                    </CloseBackDiv>
                  ) : (
                    <FilterBackDiv>
                      <FilterIconDiv className="icon icon-filter" />
                    </FilterBackDiv>
                  )}
                </FilterWrapper>
              )}
            </SearchFilter>

            <FilterOnclickDes>
              {isOpen && (
                <FilterDesWrapper>
                  <WorksiteDropdownFilter />
                </FilterDesWrapper>
              )}
            </FilterOnclickDes>

            <WorksiteMobileListWrapper>
              {/* <UserList
                pendingList={pendingList}
                style={{ boxShadow: "rgba(0, 0, 0, 0.5) 0px 8px 8px -6px" }}
                searchText={SearchText}
                setSearchText={setSearchText}
                userTypeFilter={UserTypeFilter}
                setImageLoaded={(data) => setImageLoaded(data)}
                setShowUserDetail={() => setShowUserDetail(true)}
              /> */}
              <WorksiteList
                style={{ boxShadow: "rgba(0, 0, 0, 0.5) 0px 8px 8px -6px" }}
                searchText={SearchText}
                filterAccountId={filterAccountId}
                setShowWorksiteDetail={() => setShowWorksiteDetail(true)}
              />
            </WorksiteMobileListWrapper>

            {/*<div className={`${ManagementPanelStyles.searchBoxFilter}`}>
             <div style={{ width: "88%" }}>
                <div className={`${ManagementPanelStyles.searchMobileView}`}>
                  <SearchBox
                    searchText={SearchText}
                    setSearchText={setSearchText}
                    placeholder={t("Search a worksite")}
                  />
                </div>
              </div>
              {isSuperAdmin && (
                <div style={{ width: "12%" }} className={`${ManagementPanelStyles.filterButtonStyle}`}>
                  <p onClick={() => setShowFilters(!showFilters)}>
                    {showFilters ? (
                      <button className={`${ManagementPanelStyles.filterButtonStyleHide} filterButtonCss`}>
                        <FilterIconStyled className="icon icon-filter"></FilterIconStyled>
                      </button>
                    ) : (
                      <button className={`${ManagementPanelStyles.filterButtonStyleShow} filterButtonCss`}>
                        <FilterIconStyled className="icon icon-filter"></FilterIconStyled>
                      </button>
                    )}
                  </p>
                </div>
              )} 
            </div>*/}
            {/* <div className={`${ManagementPanelStyles.filterSelectStyle}`}>
              {showFilters ? <WorksiteFiltersComponent /> : ""}
            </div>
            <div className={`${ManagementPanelStyles.mobileListingSection}`}>
              <WorksiteList
                style={{ boxShadow: "rgba(0, 0, 0, 0.5) 0px 8px 8px -6px" }}
                searchText={SearchText}
                filterAccountId={filterAccountId}
                setShowWorksiteDetail={() => setShowWorksiteDetail(true)}
              />
            </div> */}
          </>
        ) : (
          <>
            {/* <p className={`${ManagementPanelStyles.assetNameMobile} assetMobileCss`}>
              <span onClick={() => setShowWorksiteDetail(false)}>Your Worksite</span>{" "}
              <img height="15" src={rightIcon} />
              {` ${worksiteName || ""}`}
            </p>
            <WorksiteOverview filterAccountId={filterAccountId} /> */}

            <WorsiteDetailHeading>
              <span onClick={() => setShowWorksiteDetail(false)}>Your Worksite</span>{" "}
              <RightIconImage className="icon icon-arrow-right"></RightIconImage>
              {` ${worksiteName || ""}`}
            </WorsiteDetailHeading>
            <WorksiteOverview filterAccountId={filterAccountId} />
          </>
        )}
      </MobileView>
      <WoksiteCentralModal
        show={addSiteModal}
        onHide={() => {
          setAddSiteModal(false);
          setModalWaitingToOpen(false);
        }}
        toogleModalClose={() => {
          setAddSiteModal(false);
          setModalWaitingToOpen(false);
        }}
      />
      <WoksiteBulkUploadModal
        show={worksiteBulkUploadShow}
        onHide={() => setWorksiteBulkUploadShow(false)}
        toogleModalClose={() => setWorksiteBulkUploadShow(false)}
      />
      <CommonSuccessMessage />
    </WorksitePanelStyled>
  );
}

export function WoksiteCentralModal(props) {
  const { t } = useTranslation();
  return (
    <ModalPopup
      {...props}
      size="lg"
      centered
      backdrop="static"
      title={t("Add Worksite")}
      handleClose={props.toogleModalClose}
    >
      <AddWorsiteStepper />
    </ModalPopup>
  );
}

function WoksiteBulkUploadModal(props) {
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ padding: "200px", height: "500px" }}
    >
      <Modal.Body>
        <Row className="pl-4 pr-4 justify-content-center">
          <h4 className="text-style">
            <Trans>This feature will be here soon, kindly contact</Trans>{" "}
            <a href="mailto:support@siera.ai">support@siera.ai</a> <Trans>for more information</Trans>.
          </h4>
        </Row>
      </Modal.Body>
    </Modal>
  );
}

const mapStateToProps = (state) => ({
  isSuperAdmin: state.user.isSuperAdmin,
  loginDetails: state.user.loginDetails,
  accountList: state.account.accountList,
  menuList: state.sideMenu.menuState,
  addWorksiteSuccess: state.worksites.AddWorksiteSuccess,
  addWorksiteSuccessFlag: state.worksites.addWorksiteSuccessFlag,
  addWorksiteError: state.worksites.AddWorksiteError,
  worksiteMessage: state.worksites.WorksiteMessage,
  worksiteLoading: state.worksites.WorksiteLoading,
  addSiteModal: state.modals.addSiteModal,
  showFilters: state.mobileView.showFilters,
  worksiteName: state?.worksites?.WorksiteOverview?.name,
  editForm: state.forms.editForm,
});

const mapDispatchToProps = (dispatch) => ({
  getWorksites: () => dispatch(getWorksites()),
  setAddSiteModal: (data) => dispatch(setAddSiteModal(data)),
  updateActiveNavItem: (item) => dispatch(updateActiveNavItem(item)),
  setShowFilters: (data) => dispatch(setShowFilters(data)),
  setEditAlertModal: (data) => dispatch(setEditAlertModal(data)),
  setModalWaitingToOpen: (data) => dispatch(setModalWaitingToOpen(data)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(WorksitePanel));
